(function () {
  // -------------------------------
  // Helpers de fecha
  // -------------------------------
  function parseStartDate(dateStr) {
    if (!dateStr) return null;
    const parts = dateStr.split("-");
    if (parts.length !== 3) return null;
    const y = parseInt(parts[0], 10);
    const m = parseInt(parts[1], 10);
    const d = parseInt(parts[2], 10);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
  }

  function atMidnight(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function addDays(date, n) {
    const d = new Date(date);
    d.setDate(d.getDate() + n);
    return d;
  }

  // -------------------------------
  // Initialize an advent section
  // -------------------------------
  function initSection(sectionEl) {
    const startDate = parseStartDate(sectionEl.dataset.startDate);
    if (!startDate) return;

    const today = atMidnight(new Date());
    const sectionId = sectionEl.dataset.sectionId || "";
    const cards = Array.from(sectionEl.querySelectorAll(".advent-card"));

    const modal = sectionEl.querySelector(".advent-modal");
    if (!modal) return;

    const modalImg = modal.querySelector(".advent-modal__img");
    const modalLink = modal.querySelector(".advent-modal__link");

    // localStorage prefix (per section, in case there is more than one calendar)
    const keyPrefix = sectionId ? "advent_" + sectionId + "_" : "advent_";
    const storageKeyForDay = (day) => keyPrefix + "opened_day_" + day;

    // ---------------------------
    // Global handler for the modal link
    // ---------------------------
    if (modalLink) {
      modalLink.addEventListener("click", function (e) {
        // If it is a past day or flagged no-click, never navigate
        if (this.dataset.isPast === "true" || this.classList.contains("no-click")) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });
    }

    // ---------------------------
    // Open the modal from a card
    // ---------------------------
    function openModalFromCard(card) {
      if (!modal || !modalImg || !modalLink) return;

      const popupImage = card.dataset.popupImage;
      const day = card.dataset.day;
      const ctaLink = card.dataset.ctaLink;
      const isPast = card.classList.contains("is-past");

      // Mark as opened (only if it has a day)
      if (day) {
        localStorage.setItem(storageKeyForDay(day), "true");
        card.classList.add("is-openable");
      }

      // Popup image
      if (popupImage) {
        modalImg.src = popupImage;
        modalImg.alt = "";
      } else {
        modalImg.removeAttribute("src");
        modalImg.alt = "";
      }

      // Link logic:
      // - Past days => no navigation (no-click)
      // - Today, with a link => navigation enabled
      // - No link configured => no-click
      modalLink.dataset.isPast = isPast ? "true" : "false";

      if (isPast || !ctaLink) {
        // past day or no link -> disable navigation
        modalLink.href = "javascript:void(0)";
        modalLink.classList.add("no-click");
      } else {
        // current day with a link -> allow navigation
        modalLink.href = ctaLink;
        modalLink.classList.remove("no-click");
      }

      modal.classList.add("is-active");
      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    }

    // ---------------------------
    // Cerrar modal
    // ---------------------------
    function closeModal() {
      modal.classList.remove("is-active");
      modal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }

    modal.addEventListener("click", (e) => {
      if (e.target.matches("[data-modal-close]")) {
        closeModal();
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closeModal();
      }
    });

    // ---------------------------
    // State of each day
    // ---------------------------
    cards.forEach((card) => {
      const day = parseInt(card.dataset.day, 10);
      if (!day) return;

      // Day 1 = start_date, Day N = start_date + (N-1)
      const openDate = atMidnight(addDays(startDate, day - 1));

      const isFuture = today < openDate;
      const isPast = today > openDate;
      const isToday = today.getTime() === openDate.getTime();

      const wasOpened = localStorage.getItem(storageKeyForDay(day)) === "true";

      if (isFuture) {
        // Future day: locked, does not open
        card.classList.add("is-locked");
        card.setAttribute("aria-expanded", "false");
      } else {
        // Hoy o pasado
        card.setAttribute("aria-expanded", "true");

        if (isPast) {
          // Past days are always open and flagged as "past"
          card.classList.add("is-openable", "is-past");
          localStorage.setItem(storageKeyForDay(day), "true");
        }

        if (isToday) {
          card.classList.add("is-today");
          if (wasOpened) {
            // If already opened before in this browser, show it as opened
            card.classList.add("is-openable");
          }
          // If NOT opened yet:
          // - has no is-openable (renders closed)
          // - pero tampoco is-locked (sí responde al click)
        }
      }

      card.addEventListener("click", () => {
        // Only block clicks on future days
        if (card.classList.contains("is-locked")) return;
        openModalFromCard(card);
      });
    });
  }

  // -------------------------------
  // Init global
  // -------------------------------
  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll(".advent[data-start-date]")
      .forEach(initSection);
  });
})();
